import type { ShapeThumb } from '@/types/annotations'

// rc-app OverlayBox with `useCropMask`: the box's border colour floods everything
// OUTSIDE the box instead of outlining it, at rc-app's alphas — except selection,
// which keeps this app's blue (rc-app used yellow).
const MASK_COLOR: Record<ShapeThumb['type'] | 'selected', string> = {
  selected: 'color-mix(in srgb, var(--accent-blue) 60%, transparent)',
  gt: 'rgba(0, 255, 0, 0.8)',
  rejection: 'rgba(255, 0, 0, 0.8)',
  suggestion: 'rgba(0, 0, 0, 0.7)',
  roi: 'rgba(241, 163, 60, 0.8)',
  circle: 'rgba(104, 206, 103, 0.8)',
  point: 'rgba(6, 122, 255, 0.8)',
}

interface ThumbFocusMaskProps {
  /** Box rect inside the thumb, px */
  box: { left: number; top: number; width: number; height: number }
  kind: ShapeThumb['type']
  selected?: boolean
}

/** Focus mask for a rail / ground-truth thumbnail: floods outside the box in
 *  the category colour (yellow when selected), leaving the box itself clear. */
export function ThumbFocusMask({ box, kind, selected }: ThumbFocusMaskProps) {
  const l = box.left
  const t = box.top
  const r = box.left + box.width
  const b = box.top + box.height
  return (
    <div
      className="pointer-events-none absolute inset-0 transition-colors duration-[400ms]"
      style={{
        backgroundColor: MASK_COLOR[selected ? 'selected' : kind],
        clipPath: `polygon(evenodd, 0 0, 100% 0, 100% 100%, 0 100%, 0 0, ${l}px ${t}px, ${l}px ${b}px, ${r}px ${b}px, ${r}px ${t}px, ${l}px ${t}px)`,
      }}
    />
  )
}
